
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';


import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Financials from './components/Financials';
import Performance from './components/Performance';
import Projects from './components/Projects';
import Team from './components/Team';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-light text-dark font-sans">
      <Navbar />
      <Hero />
      <div className="container py-5">
        <About />
        <hr className="my-5" />
        <Projects />
        <hr className="my-5" />
        <Performance />
        <hr className="my-5" />
        <Financials />
        <hr className="my-5" />
        <Team />
      </div>
      <Footer />
    </div>
  );
}

export default App;